import { Form } from '@ant-design/compatible'

import ManageIrrigationTypeForm from './ManageIrrigationTypeForm'

export default Form.create({
  name: 'irrigationTypeForm',
})(ManageIrrigationTypeForm)
